import { getServiceUrl as a } from "../compass/compass-services.js";
import { SERVICE as n } from "../compass/services.js";
async function p(s, { redirectToPassportLogin: i } = { redirectToPassportLogin: !0 }) {
  const o = await a(n.PASSPORT);
  if (window.location.href.startsWith(o))
    return;
  const r = new URL(`${o}/logout`), t = s ?? window.location.href;
  if (i) {
    const e = new URL(`${o}/login`);
    e.searchParams.set("service", t), r.searchParams.set("redirect", btoa(e.toString()));
  } else
    r.searchParams.set("service", t);
  window.location.href = r.toString();
}
export {
  p as logout
};
